import { createContext, useContext, useState } from "react";
import { Sun, Moon } from "lucide-react";

const ThemeContext = createContext({ isDark: true, toggle: () => {} });
const STORAGE_KEY = "briarwood-theme";

function applyTheme(dark) {
  document.documentElement.classList.toggle("dark", dark);
  document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() =>
    typeof document !== "undefined" && document.documentElement.classList.contains("dark")
  );

  const toggle = () => {
    const next = !isDark;
    localStorage.setItem(STORAGE_KEY, next ? "dark" : "light");
    applyTheme(next);
    setIsDark(next);
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggle }}>{children}</ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

export function ThemeToggle({ size = 34 }) {
  const { isDark, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-pressed={isDark}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        width: size, height: size, borderRadius: 10, flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        border: "1px solid var(--w14)", background: "var(--w6)",
        color: "var(--text)", cursor: "pointer", transition: "background-color 0.2s, color 0.2s",
      }}
    >
      {isDark ? <Sun size={16} strokeWidth={2.2} /> : <Moon size={16} strokeWidth={2.2} />}
    </button>
  );
}
